import { PieChart, PieInnerText } from '@jana-technology/platform-ui/charts'
import { ErrorBoundary } from '@sentry/react'

import { useAppSelector } from 'app/hooks'

import { showRiskDensity } from 'features/RiskManagement/Components/LocalFilter/localFilterSelectors'

import { type PieChartContainerProps } from './types'
import { hasPieChartData } from './utils'

export const defaultPieChartSize = 312
export const defaultPieChartSliceGap = 2

const PieChartContent = ({
  children,
  pies,
  ...props
}: PieChartContainerProps) => {
  const density = useAppSelector(showRiskDensity)
  const shouldUseDefaultPie = !hasPieChartData(pies)

  const innerText = shouldUseDefaultPie ? null : children

  const pieChartProps = {
    size: defaultPieChartSize,
    sliceGap: defaultPieChartSliceGap,
    restrictVerticalWidth: false,
    pies,
    children,
    density,
    ...props
  }

  return <PieChart {...pieChartProps}>{innerText}</PieChart>
}

const PieChartErrorFallback = () => (
  <PieChart
    pies={[]}
    size={defaultPieChartSize}
    sliceGap={defaultPieChartSliceGap}
  >
    <PieInnerText label='Something went wrong' value='Error' />
  </PieChart>
)

const PieChartErrorBoundary = ({ children }: React.PropsWithChildren) => (
  <ErrorBoundary fallback={<PieChartErrorFallback />}>{children}</ErrorBoundary>
)

export const PieChartContainer = (props: PieChartContainerProps) => {
  return (
    <PieChartErrorBoundary>
      <PieChartContent {...props} />
    </PieChartErrorBoundary>
  )
}
